export function updateNextButton(nextBtn) {
	return {
		type: 'NEXTBTN_IS_CHECKED',
		payload: {
			nextBtn: nextBtn
		}
	}
}


export function updateConfirmButton(confirmBtn) {
	return {
		type: 'CONFIRMBTN_IS_CHECKED',
		payload: {
			confirmBtn: confirmBtn
		}
	}
}


export function updatePageNumber(page) {
	return {
		type: 'UPDATE_PAGE_NUMBER',
		payload: {
			page: page
		}
	}
}
